import { post, put, get, patch } from '@/api/rest'
import { setPoll, getPoll } from '@/store/messages'
import { getMyUser } from '@/store'
import * as translations from '@/store/translations'
import { updatePoll as updatePollStore } from '@/store/messages'

export const createPoll = async (chatId, payload) => {
	try {
		const poll = await post(`/chats/${chatId}/polls`, payload)
		setPoll(poll)
		return poll
	} catch (e) {
		console.error(e)
		throw e
	}
}

export const updatePoll = async (pollId, payload) => {
	try {
		const poll = await patch(`/polls/${pollId}`, payload)
		setPoll(poll)
		return poll
	} catch (e) {
		console.error(e)
		throw e
	}
}

export const saveVotes = async (pollId, option_ids, signal) => {
	try {
		const poll = await put(`/polls/${pollId}/votes`, { option_ids }, { signal })
		setPoll(poll)
		return poll
	} catch (e) {
		console.error(e)
		throw e
	}
}

export const searchPollVoters = async (pollId, params = {}) => {
	try {
		const resp = await get(`/polls/${pollId}/voters`, params)
		return resp
	} catch (e) {
		console.error(e)
		throw e
	}
}

export const getVotersForOption = async (pollId, optionId, params = {}) => {
	try {
		const resp = await get(
			`/polls/${pollId}/options/${optionId}/voters`,
			params
		)
		return resp
	} catch (e) {
		console.error(e)
		throw e
	}
}

export const translatePoll = async (pollId) => {
	const { language } = getMyUser()
	let poll = getPoll(pollId)
	// If already translated, just toggle off
	if (poll.isTranslated) {
		poll = updatePollStore(pollId, { isTranslated: false })
		return poll
	}

	// If we have translations already, just toggle on
	if (poll.translations?.length > 0) {
		const translation = poll.translations.find((t) => t.language === language)
		if (translation) {
			poll = updatePollStore(pollId, { isTranslated: true })
			return poll
		}
	}

	// Need to fetch translations from API
	try {
		const poll = await post(`/polls/${pollId}/translations/${language}`)
		translations.add(pollId, false, true)
		poll.isTranslated = true
		const normalizedPoll = setPoll(poll)
		return normalizedPoll
	} catch (e) {
		console.error(e)
		throw e
	}
}
